import { AnimatePresence, m } from 'framer-motion'

import { SHOW_ADD_SERVICE, useApp } from '@/lib/provider/AppProvider'

import ServiceTile from '@/pages/dashboard/partials/ServiceTile'
import CloseIcon from '@icons/x-mark'
import { useProducts } from '@/lib/hooks/useProducts'

const AddService = () => {
  const [appState, appDispatch] = useApp()
  const services = useProducts()

  const handleClose = () => {
    appDispatch({ type: SHOW_ADD_SERVICE, payload: false })
  }

  const backdropVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 },
  }

  const dialogVariants = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: { type: 'spring' as const, damping: 25, stiffness: 500 },
    },
  }

  return (
    <AnimatePresence>
      {appState.isAddServiceShown && (
        <m.div
          className="z-40 select-none fixed inset-0 il-dialog h-screen"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <m.div
            className="bg-auxiliary-3/80 fixed top-0 left-0 w-full h-full overflow-hidden z-50 cursor-default transition-all backdrop-blur-sm"
            variants={backdropVariants}
            onClick={handleClose}
          />

          <div className="flex items-center justify-center h-screen py-4">
            <m.div
              className="max-w-3xl flex flex-col rounded-lg bg-neutral-10 shadow-2xl overflow-auto relative z-60 h-full sm:h-auto sm:max-h-[90vh]"
              variants={dialogVariants}
            >
              <CloseIcon
                className="absolute right-4 top-4 md:right-8 md:top-8 text-sm cursor-pointer"
                onClick={handleClose}
              />
              <div className="">
                <div className="bg-white p-6 border-b shadow-lg shadow-neutral-20 border-neutral-20">
                  <h4 className="text-accent-60 text-lg font-bold">
                    Add a Service
                  </h4>
                  <p className="text-gray-500 text-sm leading-4">
                    We're designing a suite of services to meet all of your
                    connectivity needs.
                  </p>
                </div>

                <div className="grid sm:grid-cols-2 gap-2 px-4 py-8 overflow-auto">
                  {services.map((serviceItem) => (
                    <ServiceTile
                      key={serviceItem.id}
                      serviceItem={serviceItem}
                      onClick={() => {
                        if (serviceItem.cta) {
                          handleClose()
                        }
                      }}
                    />
                  ))}
                </div>
              </div>
            </m.div>
          </div>
        </m.div>
      )}
    </AnimatePresence>
  )
}

export default AddService
